export default "__VITE_ASSET__af35a5cf__"